module.exports = "/images/Latam_v2.png?6d011b79dc98eb24cf014a5662a7a4df";